import { css } from 'styled-components'

const focusedInput = css<{ hasExceededMaxCount?: boolean }>`
  box-shadow: 0px 0px 1.5px 3.5px
    ${(props: { hasExceededMaxCount?: boolean } = {}) =>
      props?.hasExceededMaxCount
        ? 'var(--chakra-colors-red-subtle)'
        : 'var(--chakra-colors-brand-subtle)'};
  background-color: var(--chakra-colors-bg-panel);
  border: 1.25px solid
    ${(props: { hasExceededMaxCount?: boolean } = {}) =>
      props?.hasExceededMaxCount
        ? 'var(--chakra-colors-red-solid)'
        : 'var(--chakra-colors-fg-muted)'};
  outline-offset: 0;
  outline: none;
`

const easeInOutTransition = css`
  transition: all 0.15s ease-in-out;
`

const backgroundBoxShadow = css`
  box-shadow: 0px 8px 24px 4px rgba(0, 43, 64, 0.035);
`

const blurybackground = css`
  backdrop-filter: blur(8px);
  background-color: rgba(250, 250, 252, 0.85);
`

export {
  focusedInput,
  easeInOutTransition,
  backgroundBoxShadow,
  blurybackground,
}
